import { UserSettingsProvider } from './contexts/UserSettingsContext';
import { UserSettingsPage } from './UserSettingsPage';

export const UserSettingsPageWrapper = () => {
  return (
    <UserSettingsProvider>
      <UserSettingsPage />
    </UserSettingsProvider>
  )
}